import { Box, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { spaces, palette } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';
import { useTranslation } from 'react-i18next';

interface BenefitsProps {
  benefit: { title?: string; features: { text: string, isHighlighted?: boolean, isBonus?: boolean }[] };
}
const Benefits: React.FC<BenefitsProps> = ({ benefit }) => {
  const { t } = useTranslation();

  return (
    <Box data-testid='pricing-package-benefit-item' sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: spaces.sm,
    }}>
      {benefit.title && (
        <Typography variant='h6' color={palette.text.primary} sx={{
          fontWeight: 600,
        }}>
          {t(benefit.title)}
        </Typography>
      )}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spaces.xs,
      }}>
        {
          benefit.features.map((feature, index) => (
            <Box key={index} sx={{ display: 'flex', gap: spaces.xs, alignItems: 'center' }}>
              {
                feature.isHighlighted ? (
                  <SvgIcon
                    component={getMuiIcon('checkOutlineVerify')}
                  />
                ) : (
                  <SvgIcon
                    component={getMuiIcon('checkVerify')}
                  />
                )
              }
              <Typography 
                variant='body2' 
                sx={{ 
                  color: feature.isHighlighted ? palette.primary.main : palette.text.secondary,
                  fontWeight: feature.isHighlighted ? 500 : 300, 
                }}
              >
                {t(feature.text)}
              </Typography>
              {feature.isBonus && (
                <Typography 
                  variant='overline'
                  color={palette.success.main}
                >
                  {t('BONUS')}
                </Typography>
              )}
            </Box>
          ))
        }
      </Box>
    </Box>
  );
};

export default Benefits;
